import { c as create_ssr_component, v as validate_component, f as each, e as escape } from "./ssr.js";
import { S as StdHeading, a as StdParagraph, B as Button } from "./Button.js";
const SubHeading_svelte_svelte_type_style_lang = "";
const css$3 = {
  code: ".subheading.svelte-tu4xmv{color:rgba(21,24,28,0.7);font-size:1.6rem}",
  map: null
};
const SubHeading = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  $$result.css.add(css$3);
  return `<div class="subheading svelte-tu4xmv">${slots.default ? slots.default({}) : ``} </div>`;
});
const ContactUsSection_svelte_svelte_type_style_lang = "";
const css$2 = {
  code: ".contact_us.svelte-ip6uvv.svelte-ip6uvv{padding:10rem 8rem;padding-right:0;display:flex;align-items:center;gap:60px}@media(max-width: 1000px){.contact_us.svelte-ip6uvv.svelte-ip6uvv{padding:60px 20px;padding-right:0;flex-direction:column}}.contact_us.svelte-ip6uvv .left_side.svelte-ip6uvv{display:flex;flex-direction:column;gap:2rem;max-width:80rem}.contact_us.svelte-ip6uvv .right_side.svelte-ip6uvv{background-color:#0e76bc;padding:4rem 3rem;border-radius:2rem 0 0 2rem;display:flex;flex-direction:column;gap:2rem;max-width:80rem;margin-left:auto}.contact_us.svelte-ip6uvv .right_side .heading.svelte-ip6uvv{font-size:2.2rem;font-weight:500}.contact_us.svelte-ip6uvv .right_side .button_wrapper.svelte-ip6uvv{margin-left:auto}.seperating_line.svelte-ip6uvv.svelte-ip6uvv{height:0.1rem;width:80%;background-color:#15181c}.hero.svelte-ip6uvv.svelte-ip6uvv{width:100%;height:90vh;background-size:cover;background-repeat:no-repeat;padding:5rem 0}@media(max-width: 1000px){.hero.svelte-ip6uvv.svelte-ip6uvv{padding:0}}.what_you_waiting_for_heading.svelte-ip6uvv.svelte-ip6uvv{background-color:#fff;padding:2rem;width:60rem;display:flex;justify-content:center;align-items:center;border-radius:0 5rem 5rem 0}@media(max-width: 1000px){.what_you_waiting_for_heading.svelte-ip6uvv.svelte-ip6uvv{width:100%;border-radius:0}}",
  map: null
};
const ContactUsSection = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  $$result.css.add(css$2);
  return ` <div class="hero svelte-ip6uvv" style="background-image: url('/cockpit_with_student.webp');"><div class="what_you_waiting_for_heading svelte-ip6uvv">${validate_component(StdHeading, "StdHeading").$$render($$result, { color: "blue", font_family: "Inter" }, {}, {
    default: () => {
      return `What Are You Waiting For?`;
    }
  })}</div></div> <div class="contact_us svelte-ip6uvv"><div class="left_side svelte-ip6uvv">${validate_component(SubHeading, "SubHeading").$$render($$result, {}, {}, {
    default: () => {
      return `GET IN TOUCH TO LEARN MORE`;
    }
  })} <div class="seperating_line svelte-ip6uvv"></div> ${validate_component(StdHeading, "StdHeading").$$render($$result, { font_family: "Inter" }, {}, {
    default: () => {
      return `CONTACT US`;
    }
  })} ${validate_component(StdParagraph, "StdParagraph").$$render($$result, { color: "dark" }, {}, {
    default: () => {
      return `If you have any questions about our school and programs or would like to
      schedule a tour please give us a call or send us a message. We look
      forward to helping you realize your dreams of flight.`;
    }
  })}</div> <div class="right_side svelte-ip6uvv"><div class="heading svelte-ip6uvv" data-svelte-h="svelte-qz57y9">Contact one of our instructors today</div> ${validate_component(StdParagraph, "StdParagraph").$$render($$result, { color: "white" }, {}, {
    default: () => {
      return `Want to start exploring your flight training or career track in aviation?
      Reach out to us and one of our Training Advisors will address any
      inquiries you may have. We&#39;re are here to provide you with comprehensive
      insights and guide you through the exciting possibilities that aviation
      training and careers have to offer. Your aspirations are important to us,
      and we&#39;re committed to assisting you every step of the way.`;
    }
  })} <div class="button_wrapper svelte-ip6uvv">${validate_component(Button, "Button").$$render($$result, { href: "/contact-us", color: "orange" }, {}, {
    default: () => {
      return `Contact Us Now`;
    }
  })}</div></div> </div>`;
});
const Reviews_svelte_svelte_type_style_lang = "";
const css$1 = {
  code: '.clients.svelte-13ksogv.svelte-13ksogv{display:flex;background:#f36d21;padding:10rem;justify-content:space-between;gap:5rem}@media(max-width: 1024px){.clients.svelte-13ksogv.svelte-13ksogv{flex-direction:column}}@media(max-width: 1000px){.clients.svelte-13ksogv.svelte-13ksogv{padding:40px 20px}}.clients.svelte-13ksogv .contents.svelte-13ksogv{width:50%;display:flex;flex-direction:column;gap:2rem;color:#fff}@media(max-width: 1200px){.clients.svelte-13ksogv .contents.svelte-13ksogv{width:auto}}.clients.svelte-13ksogv .contents .line.svelte-13ksogv{width:100%;height:0.1rem;background-color:#fff;opacity:0.5}.clients.svelte-13ksogv .contents .text.svelte-13ksogv{display:flex;flex-direction:column;gap:3rem;color:#000}.clients.svelte-13ksogv .contents .text .box.svelte-13ksogv{padding:36px;padding:3.6rem;background:#fff;display:flex;flex-direction:column;gap:2rem;border-radius:2rem}.clients.svelte-13ksogv .image.svelte-13ksogv{border-radius:30rem 30rem 0 0;border:0.1rem solid #fff;background-image:url("/plane_away.webp");background-size:cover;min-width:50rem;background-position:35% 0;position:relative}@media(min-width: 431px) and (max-width: 1024px){.clients.svelte-13ksogv .image.svelte-13ksogv{border-radius:2rem}}@media(max-width: 1200px){.clients.svelte-13ksogv .image.svelte-13ksogv{min-height:600px;min-width:auto}}.clients.svelte-13ksogv .image img.svelte-13ksogv{position:absolute;top:-3rem;right:-5rem;width:50%}.name.svelte-13ksogv.svelte-13ksogv{font-weight:500;font-size:1.6rem}',
  map: null
};
const Reviews = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let heading_size;
  let reviews = [
    {
      text: "These group of pilots and trainers are professional and experienced. They have a diverse training staff. So whether it’s age, gender, or personality you are seeking then First Landings may be the place for you. As an executive of this firm my schedule is packed. The team here works with me all the time to ensure I have consistent flight time flying the aircraft I prefer. I am satisfied i choose them for my flight instruction. Come and try a discovery flight.",
      name: "Mark Anderson"
    },
    {
      text: "I want to thank everyone on the first landings team for everything that they did for me to get me to my private pilots certification. Everyone was great to work with and be around. The energy they bring is awesome. I want to give a special shout out to Sean. I did most of my training with him. This guy knows his stuff! He has experience, professionalism and most of all patience. Awesome instructor.",
      name: "Ryan Gonzalez"
    },
    {
      text: "Started my aviation training here and had an amazing experience. I was able to pass my written test and private pilots check-ride on the first attempt for both, due to the amazing training i received. They have very experienced flight instructors there that want to see you strive. The pricing is very reasonable and the aircraft are well maintained. Any issue I found they addressed it right away and get it safely resolved.",
      name: "Bradley Doss"
    }
  ];
  $$result.css.add(css$1);
  heading_size = "small";
  return ` <div class="clients svelte-13ksogv"><div class="contents svelte-13ksogv">${validate_component(StdHeading, "StdHeading").$$render($$result, { color: "white", size: heading_size }, {}, {
    default: () => {
      return `HEAR FROM OUR CLIENTS`;
    }
  })} <div class="line svelte-13ksogv"></div> <div class="text svelte-13ksogv">${each(reviews, (review) => {
    return `<div class="box svelte-13ksogv">${validate_component(StdParagraph, "StdParagraph").$$render($$result, { font_style: "italic", color: "dark" }, {}, {
      default: () => {
        return `“${escape(review.text)}“
          `;
      }
    })} <span class="name svelte-13ksogv">- ${escape(review.name)}</span> </div>`;
  })}</div></div> <div class="image svelte-13ksogv">${``}</div> </div>`;
});
const FinancingCard_svelte_svelte_type_style_lang = "";
const css = {
  code: ".financing-card.svelte-1jnj99m{width:100%;display:flex;flex-direction:column;gap:2rem;padding:5rem;padding-top:2rem;padding-bottom:14rem;position:relative}@media(max-width: 1024px){.financing-card.svelte-1jnj99m{padding:40px}}img.svelte-1jnj99m{position:absolute;top:-3rem;right:10rem;width:40rem;pointer-events:none}@media(max-width: 1024px){img.svelte-1jnj99m{position:static;width:50%;margin:auto}}@media(max-width: 700px){img.svelte-1jnj99m{width:100%}}.seperating_line.svelte-1jnj99m{height:0.1rem;width:30rem;background-color:#15181c}",
  map: null
};
const FinancingCard = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  $$result.css.add(css);
  return ` <div class="financing-card svelte-1jnj99m">${validate_component(SubHeading, "SubHeading").$$render($$result, {}, {}, {
    default: () => {
      return `FINANCING AVAILABLE!`;
    }
  })} <div class="seperating_line svelte-1jnj99m"></div> ${validate_component(StdHeading, "StdHeading").$$render($$result, { size: "large" }, {}, {
    default: () => {
      return `Wondering how to pay?`;
    }
  })} ${validate_component(StdParagraph, "StdParagraph").$$render(
    $$result,
    {
      color: "dark",
      max_width: "100%"
    },
    {},
    {
      default: () => {
        return `First Landings offers financing options with the ability to finance 100% of
    your flight training for reasonable rates. The application process is fairly
    quick and most applicants have received short response times. Feel free to
    ask us questions about our partner financing programs.`;
      }
    }
  )} <div style="margin-right: auto;">${validate_component(Button, "Button").$$render($$result, { href: "/financing", color: "orange" }, {}, {
    default: () => {
      return `Apply for Financing`;
    }
  })}</div> <img src="/four_planes.svg" alt="four planes" class="svelte-1jnj99m"> </div>`;
});
export {
  ContactUsSection as C,
  FinancingCard as F,
  Reviews as R
};
